export const requestyModels = {
    id: "requesty",
    name: "Requesty",
    npm: "@requesty/ai-sdk",
    doc: "https://requesty.ai/solution/llm-routing/models",
    env: ["REQUESTY_API_KEY"],
    models: {
        "anthropic/claude-opus-4": {
            id: "anthropic/claude-opus-4",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-opus-4-1-20250805": {
            id: "anthropic/claude-opus-4-1-20250805",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 15,
                output: 75,
                cache_read: 1.5,
                cache_write: 18.75,
            },
            limit: {
                context: 200000,
                output: 32000,
            },
        },
        "anthropic/claude-3-7-sonnet": {
            id: "anthropic/claude-3-7-sonnet",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-01",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "anthropic/claude-4-sonnet-20250522": {
            id: "anthropic/claude-4-sonnet-20250522",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 3,
                output: 15,
                cache_read: 0.3,
                cache_write: 3.75,
            },
            limit: {
                context: 200000,
                output: 64000,
            },
        },
        "openai/gpt-5-nano": {
            id: "openai/gpt-5-nano",
            name: "GPT-5 Nano",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.05,
                output: 0.4,
                cache_read: 0.01,
            },
            limit: {
                context: 16000,
                output: 4000,
            },
        },
        "openai/gpt-4.1": {
            id: "openai/gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 2,
                output: 8,
                cache_read: 0.5,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/gpt-5": {
            id: "openai/gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-09-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "audio", "image", "video"],
                output: ["text", "audio", "image"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.13,
            },
            limit: {
                context: 400000,
                output: 128000,
            },
        },
        "openai/gpt-5-mini": {
            id: "openai/gpt-5-mini",
            name: "GPT-5 Mini",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05-30",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.25,
                output: 2,
                cache_read: 0.03,
            },
            limit: {
                context: 128000,
                output: 32000,
            },
        },
        "openai/gpt-4o-mini": {
            id: "openai/gpt-4o-mini",
            name: "GPT-4o Mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2024-07-18",
            last_updated: "2024-07-18",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.15,
                output: 0.6,
                cache_read: 0.08,
            },
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "openai/gpt-4.1-mini": {
            id: "openai/gpt-4.1-mini",
            name: "GPT-4.1 Mini",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.4,
                output: 1.6,
                cache_read: 0.1,
            },
            limit: {
                context: 1047576,
                output: 32768,
            },
        },
        "openai/o4-mini": {
            id: "openai/o4-mini",
            name: "o4 Mini",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.1,
                output: 4.4,
                cache_read: 0.28,
            },
            limit: {
                context: 200000,
                output: 100000,
            },
        },
        "google/gemini-2.5-pro": {
            id: "google/gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 1.25,
                output: 10,
                cache_read: 0.31,
                cache_write: 2.375,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
        "google/gemini-2.5-flash": {
            id: "google/gemini-2.5-flash",
            name: "Gemini 2.5 Flash",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-06-17",
            last_updated: "2025-06-17",
            modalities: {
                input: ["text", "image", "audio", "video", "pdf"],
                output: ["text"],
            },
            open_weights: false,
            cost: {
                input: 0.3,
                output: 2.5,
                cache_read: 0.075,
                cache_write: 0.55,
            },
            limit: {
                context: 1048576,
                output: 65536,
            },
        },
    },
};
export default requestyModels;
//# sourceMappingURL=requesty.js.map